// Interfaces
import type { ModelRef, Ref } from 'vue'

export interface State {
  banners: Record<SignInViewBanner, {
    isVisible: Ref<boolean>
  }>,
  currentBanner: Ref<SignInViewBanner | null>
}

export interface BannerSettings {
  isVisible: boolean
  text: string
  rootCssClasses: string
}

export type BannersSettings = Record<SignInViewBanner, BannerSettings>

// Enums
export enum SignInViewBanner {
  WrongCredentials = 0,
  InternalServerError = 1,
  NetworkError = 2,
  MaintenanceMode = 3,
  UnknownError = 4,
  PasswordResetSent = 5,
  SaveSuccess = 6,
}
